import { MoneyInput } from '@/components';
import { FieldBase } from '@/components/form';
import { useEinstellungenFormContext } from '@/domain/controlling/pages/Umsatzplanung/Einstellungen/Forms/EinstellungenForm/useEinstellungenFormContext';
import { useTranslation } from 'react-i18next';

export function UmsatzProduktivitaetForm() {
  const { t } = useTranslation();
  const form = useEinstellungenFormContext();

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        form.handleSubmit();
      }}
      className="flex flex-col gap-2">
      <form.AppField name="zielProduktivitaetUmsatz">
        {(field) => (
          <FieldBase
            label={t(
              'domain.controlling.umsatzplanung.einstellungen.inputs.zielProduktivitaetUmsatz.label',
            )}>
            <MoneyInput
              isIconVisible={false}
              unit={t('domain.controlling.umsatzplanung.ziele.€/Std.')}
              value={field.state.value}
              onBlur={(e) => {
                field.handleChange(e.target.value);
              }}
              onInput={(e) => {
                field.handleChange(e.currentTarget.value);
              }}
            />
          </FieldBase>
        )}
      </form.AppField>
    </form>
  );
}
